export enum RecommendationGender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export interface Recommendation {
    sku: string;
    brand: string;
    brandCode: string;
    categoryId: number;
    images: string[];
    simples: {
        sku: string;
        price: number;
        specialPrice: number;
        filterName: string;
        filterValue: string;
        stockStatus: string;
        stockHasReservations: boolean;
    }[];
    hasSimilar: boolean;
    urlPath: {
        [key: number]: string;
    };
    stockStatus: string;
    campaignIdentifier: string;
    plusEarlyAccess?: boolean;
}

export interface RecommendationLegacy {
    sku: string;
    urlPath: {
        [key: string]: string;
    };
    brand: string;
    brandCode: string;
    specialPrice: number;
    price: number;
    imageUrl: string;
    campaignIdentifier: string;
    categoryId: number;
    plusEarlyAccess?: boolean;
}
